import * as React from 'react'

import { ChevronDownIcon } from '~/client/src/shared/components/icons/ChevronDownIcon'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { Tag } from '../Tag/Tag'

interface IProps {
  isExpanded: boolean
  hiddenCount: number
  onToggle: (event: React.MouseEvent) => void
}

export const TagOverflowToggle = React.forwardRef<HTMLButtonElement, IProps>(
  ({ isExpanded, hiddenCount, onToggle }, ref) => (
    <button
      ref={ref}
      type="button"
      data-slot="tag-overflow-toggle"
      onPointerDown={event => event.stopPropagation()}
      onClick={onToggle}
      className="tw:cursor-pointer tw:border-0 tw:bg-transparent tw:p-0 tw:shrink-0"
    >
      <Tag
        trailing={
          <ChevronDownIcon
            size="xs"
            className={isExpanded ? 'tw:rotate-180' : undefined}
          />
        }
      >
        {isExpanded
          ? Localization.translator.showLess
          : Localization.translator.plusXMore(hiddenCount)}
      </Tag>
    </button>
  ),
)

TagOverflowToggle.displayName = 'TagOverflowToggle'
